import { makeStyles } from '@material-ui/core/styles';

import { COLORS } from 'src/data/ui';

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      padding: theme.spacing(1.25),
      backgroundColor: COLORS.neutral.white,
      border: theme.shape.borderPrimaryLight,
      borderRadius: theme.shape.borderRadius,

      display: 'flex',
      flexFlow: 'row nowrap',
    },

    content: {
      display: 'flex',
      flexFlow: 'column nowrap',
      flex: 1,
      marginLeft: theme.spacing(1.5),
    },
    row: {
      display: 'flex',
      flexFlow: 'row nowrap',
      justifyContent: 'space-between',

      '& + &': {
        marginTop: theme.spacing(1.5),
      },
    },
    circle: {
      width: 24,
      height: 24,
    },
    rectSmall: {
      borderRadius: theme.shape.borderRadiusSmall,
      width: 80,
      height: 18,
    },
    rect: {
      borderRadius: theme.shape.borderRadiusMedium,
      width: 'calc((100% - 36px) / 2)',
      height: 40,
    },
  }),
  { name: 'DetectedBrandTermSkeleton' }
);
